import {
  TOGGLE_STORES,
  GET_STORES,
  SET_STORES,
  SET_ALL_STORES,
  SET_STORES_ERROR,
  FILTER_STORES
} from './store.types';
import { AnyAction, Reducer } from 'redux';
import { StoreState } from 'models/redux/store.state';

const initialState: StoreState = {
  storesVisible: false,
  loadingStores: false,
  stores: [],
  filteredStores: [],
  filterStr: null,
  allStores: [],
  allStoresCity: '',
  groupedStores: [],
  focusedStore: undefined
};

const reducer: Reducer<StoreState> = (
  state: StoreState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case SET_STORES:
      return { ...state, ...action.payload, loadingStores: false };

    case TOGGLE_STORES:
      return { ...state, ...action.payload };

    case GET_STORES:
      return { ...state, loadingStores: true };

    case SET_STORES_ERROR:
      return { ...state, loadingStores: false };

    case FILTER_STORES:
      return { ...state, ...action.payload };

    case SET_ALL_STORES:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default reducer;
